<template>
<div>
    <v-card>
        <v-card-title primary-title>
            <v-icon class="pr-2" color="primary">view_module</v-icon>
            <div class="important">{{ $t('sheet.inventory_modal.tittle') }}</div>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
            <div class="">
                <div class="">
                    <span class="title pr-2">{{ $t('sheet.pricing_modal.apply') }}</span>
                    <span class="subheading">Doar tipurile de masa selectate vor fi actualizate</span>
                </div>
                <div column class="py-2 px-4">
                    <v-row v-for="room in room_types" :key="'room_'+room.id" align="center">
                        <v-col class="py-0" cols="8">
                            <v-checkbox class="pa-0 ma-0" v-model="room_types_selected" :value="room.id" color="primary" @change="room_types_selected.includes(room.id)?'':room.price=null">
                                <template v-slot:label>
                                    <span v-if="room.name">{{room.name}}</span>
                                    <span v-else>{{$t('room_type_slug.' +room.slug)}}</span>
                                    <span class="faded">({{room.id}})</span>
                                </template>
                            </v-checkbox>
                        </v-col>
                        <v-col class="py-0" cols="4">
                            <v-text-field :label="$t('sheet.pricing_modal.price')" v-model="room.price" class="pa-0 ma-0" :disabled='room_types_selected.includes(room.id)?false:true' :suffix="currency"></v-text-field>
                        </v-col>
                    </v-row>
                </div>
            </div>
            <v-divider></v-divider>
            <div class="">
                <div class="">
                    <span class="title pr-2">{{ $t('sheet.inventory_modal.valibility_and_weekdays') }}</span>
                    <span class="subheading">{{ $t('sheet.inventory_modal.message.room_selection') }}</span>
                </div>
                <div class="d-flex">
                    <v-menu transition="scale-transition" offset-y min-width="max-content">
                        <template v-slot:activator="{ on }">
                            <v-text-field v-on="on" v-model="period.start" :label="$t('sheet.inventory_modal.start_date')" prepend-icon="event" readonly></v-text-field>
                        </template>
                        <v-date-picker v-model="period.start" :min="today" no-title max-width="265"></v-date-picker>
                    </v-menu>
                    <v-menu transition="scale-transition" offset-y min-width="max-content">
                        <template v-slot:activator="{ on }">
                            <v-text-field v-on="on" v-model="period.stop" :label="$t('sheet.inventory_modal.end_date')" prepend-icon="arrow_right_alt" readonly></v-text-field>
                        </template>
                        <v-date-picker v-model="period.stop" :min="period.start" no-title max-width="265"></v-date-picker>
                    </v-menu>
                </div>
                <v-row class="px-2">
                    <v-btn v-for="(day,index) in days" :key="'day_'+index" small rounded depressed class="weekend-days regular mx-1" :color="weekdays.includes(day.value) ? 'primary' : 'grey lighten-2'" @click="selectDays(day.value)">
                        <span class="text-capitalize">{{ $t('week_days_short.' + day.text) }}</span>
                    </v-btn>
                </v-row>
            </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="px-2">
            <v-spacer></v-spacer>
            <v-btn text @click="emitExit">
                {{ $t('button.cancel') }}
            </v-btn>
            <v-btn dark color="primary" :loading="loading" @click="save">
                {{ $t('button.update') }}
            </v-btn>
        </v-card-actions>
    </v-card>
</div>
</template>

<script>
import {
    mapActions
} from 'vuex';
export default {
    name: `inventory-card`,

    props: {
        hotel_id: Number,
        room_types: Array,
        dialog_status: Boolean,
        currency: String,
        date_period: {
            type: Object,
            default () {
                return {
                    start: null,
                    stop: null
                }
            }
        }
    },
    data() {
        return {
            loading: false,
            period: {
                start: this.date_period.start,
                stop: this.date_period.stop
            },
            today: new Date()
                .toISOString()
                .substr(0, 10),
            room_types_selected: [],
            weekdays: [0, 1, 2, 3, 4, 5, 6],
            days: [{
                    text: "monday",
                    value: 1
                }, {
                    text: "tuesday",
                    value: 2
                }, {
                    text: "wednesday",
                    value: 3
                }, {
                    text: "thursday",
                    value: 4
                }, {
                    text: "friday",
                    value: 5
                }, {
                    text: "saturday",
                    value: 6
                }, {
                    text: "sunday",
                    value: 0
                }
            ],
        }
    },
    watch: {
        // reset to default values
        dialog_status: {
            handler(old) {
                if(old == false) {
                    this.room_types.forEach(function (room) {
                        room.price = null;
                    }.bind(this))
                    this.weekdays = [0, 1, 2, 3, 4, 5, 6];
                    this.room_types_selected = [];
                    this.period = {
                        'start': this.date_period.start,
                        'stop': this.date_period.stop
                    };
                }
            }
        },

        date_period: {
            handler() {
                this.period = {
                    'start': this.date_period.start,
                    'stop': this.date_period.stop
                };
            }
        },

        'period.start'(newVal) {
            let value = this.$moment(this.period.start)
                .isBefore(this.period.stop)
            if(!value) {
                this.period.stop = null;
            }
        }
    },

    methods: {
        ...mapActions('alert', ['success', 'error']),

        emitExit() {
            this.$emit('close');
        },

        selectDays(value) {
            if(this.weekdays.includes(value)) {
                let index = this.weekdays.indexOf(value);
                if(index > -1) {
                    this.weekdays.splice(index, 1);
                }
            } else {
                this.weekdays.push(value)
            }
        },

        save() {
            this.loading = true;
            let pricing = {
                room_types: {}
            };
            this.room_types.forEach(function (room) {
                if(this.room_types_selected.includes(room.id)) {
                    pricing.room_types[room.id] = {
                        'price': room.price
                    }
                }
            }.bind(this))

            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/console/v1/components/bulk-update';

            // setup query params
            let params = {
                hotel_id: this.hotel_id,
                date_start: this.period.start,
                date_stop: this.period.stop,
                weekdays: this.weekdays,
                pricing: pricing
            };
            this.$axios.post(endpoint, params)
                .then(response => {
                    this.success(this.$t('sheet.inventory_modal.message_updated'));
                    this.$emit('close');
                    this.$emit('refresh');
                })
                .catch(error => {
                    this.error('Ooops, something gone wrong');
                    console.log(error);
                })
                .finally(() => {
                    this.loading = false;
                });
        }
    }
}
</script>
<style lang="stylus">
.weekend-days
    &.v-btn
        min-width: 55px
</style>
